import { Button, Link, TextField } from "@mui/material";
import styled from "styled-components";
import { media } from "../../../theme/breakpoints";
import theme from "../../../theme/theme";

export const StyledCard = styled.div`
    width: 100%;
    max-width: 450px;
    background: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 40px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 20px;

    ${media.sm} {
        padding: 32px;
        gap: 28px;
    }

    ${media.md} {
        padding: 40px;
        gap: 40px;
    }
`;

export const Header = styled.h1`
    font-family: 'Manrope', sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    color: #262626;
    letter-spacing: -0.02em;
    align-self: center;

    ${media.sm} {
        font-size: 22px;
        line-height: 30px;
    }

    ${media.md} {
        font-size: 24px;
        line-height: 33px;
    }
`;

export const Subtext = styled.p`
    font-family: 'Manrope', sans-serif;
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
    color: #262626;
    letter-spacing: -0.02em;
    align-self: center;
    text-align: center;
    margin-top: -12px;

    ${media.sm} {
        font-size: 14px;
        line-height: 20px;
        margin-top: -16px;
    }

    ${media.md} {
        margin-top: -20px;
    }
`;

export const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 12px;

    ${media.sm} {
        gap: 14px;
    }

    ${media.md} {
        gap: 20px;
    }
`;

export const Row = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;

    ${media.sm} {
        flex-direction: row;
        gap: 14px;
    }

    ${media.md} {
        gap: 20px;
    }
`;

export const StyledTextField = styled(TextField)`
    && {
        .MuiOutlinedInput-root {
            border-radius: 16px;
            background-color: #ffffff;

            & fieldset {
                border-color: #e0e0e0;
            }

            &:hover fieldset {
                border-color: ${theme.palette.primary.main};
            }
            &.Mui-focused fieldset {
                border-color: ${theme.palette.primary.main};
            }
            &.Mui-focused {
                color: ${theme.palette.primary.main};
            }
        }

        input {
            font-family: 'Manrope', sans-serif;
            font-size: 14px;
            line-height: 20px;
            color: #262626;
        }

        input:-webkit-autofill {
            box-shadow: 0 0 0 1000px #ffffff inset;
            -webkit-text-fill-color: #262626;
        }
    }
`;

export const CheckboxWrapper = styled.label`
    display: flex;
    align-items: flex-start;
`;

export const CheckboxText = styled.span`
    font-family: 'Manrope', sans-serif;
    font-size: 10px;
    line-height: 120%;
    letter-spacing: -0.02em;
    color: #262626;
`;

export const StyledButton = styled(Button)`
    && {
        width: 100%;
        height: 60px;
        background-color: ${theme.palette.primary.main};
        border-radius: 16px;
        font-family: 'Manrope', sans-serif;
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: -0.02em;
        color: #fafafa;
        text-transform: none;

        &:hover {
            background-color: #152033;
        }

        &:disabled {
            background-color: rgba(29, 42, 65, 0.12);
            color: rgba(0, 0, 0, 0.26);
        }
    }
`;

export const StyledLinkWrapper = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;
    font-family: 'Manrope', sans-serif;
    font-size: 14px;
    line-height: 20px;
    color: #262626;
    flex-wrap: wrap;
`;

export const StyledLink = styled(Link)<{ disabled?: boolean }>`
        && {
        font-size: 14px;
        color: ${theme.palette.primary.main};
        letter-spacing: -0.02em;
        cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
        opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
        text-decoration: underline;

        &:hover {
            text-decoration: ${({ disabled }) => (disabled ? 'underline' : 'none')};
        }
    }
`;
